import { Language } from '@zond/api-interfaces';

/** localStorage key holding the user's chosen UI language. */
export const LANGUAGE_STORAGE_KEY = 'zond.language';

/** Languages surfaced in the web-app switcher (subset of the shared Language enum). */
export const SUPPORTED_LANGUAGES: { value: Language; label: string }[] = [
  { value: Language.English, label: 'English' },
  { value: Language.Russian, label: 'Русский' },
];

const SUPPORTED_VALUES = SUPPORTED_LANGUAGES.map((l) => l.value);

export const DEFAULT_LANGUAGE = Language.English;

/** Normalize an arbitrary value to a supported language, falling back to the default. */
export const normalizeLanguage = (value: string | null | undefined): Language => {
  if (value && SUPPORTED_VALUES.includes(value as Language)) {
    return value as Language;
  }
  return DEFAULT_LANGUAGE;
};

/** Read the persisted language from localStorage (used to bootstrap i18next before login). */
export const getStoredLanguage = (): Language => {
  try {
    return normalizeLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY));
  } catch {
    return DEFAULT_LANGUAGE;
  }
};

/** Persist the chosen language to localStorage. */
export const setStoredLanguage = (language: Language): void => {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  } catch {
    /* ignore storage errors (private mode, etc.) */
  }
};
